import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Locale } from '@medable/i18n-core-v4';
import { LocaleContext } from './i18n_context';
export const formatStudyString = (value, locale) => {
    const formattedValue = value !== null && value !== void 0 ? value : '';
    if (!new Locale(locale).isPseudoLocale) {
        return formattedValue;
    }
    return `[study:${formattedValue}]`;
};
export const useStudyString = (value) => {
    const locale = useContext(LocaleContext);
    return formatStudyString(value, locale);
};
export const StudyString = ({ children, value }) => {
    const formattedValue = useStudyString(value !== null && value !== void 0 ? value : (typeof children === 'string' ? children : ''));
    return _jsx(_Fragment, { children: formattedValue });
};
//# sourceMappingURL=study_string.js.map